import { render, staticRenderFns } from "./AddAssistantCard.vue?vue&type=template&id=17b50952"
import script from "./AddAssistantCard.vue?vue&type=script&lang=js"
export * from "./AddAssistantCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports